import './App.css';
import Intake from './intake/intake';
import ours from '@oursprivacy/cdp-sdk';

// Initialize Ours SDK only if token is provided and is a string
const oursToken = process.env.REACT_APP_OURS_TOKEN;
if (oursToken && typeof oursToken === 'string' && oursToken.trim()) {
  ours.init(oursToken);
} else {
  console.warn('Ours SDK token not provided. Ours tracking will be disabled.');
}

function App() {
  return (
    <div className="App">
      <Intake />
    </div>
  );
}

export default App;
